import { TAG_LIST_ACTION_MAP } from "../actions/types";

// the tag lists themselves live in the client, matter and document reducers;
// this only tracks which of them are out of date, keyed by endpoint
const initialState = {
	// endpoint -> true when its last refresh was rate limited
	staleLists: {},
};

const tagListResultTypes = Object.values(TAG_LIST_ACTION_MAP).flatMap(
	(type) => [type + "_SUCCESS", type + "_FAILURE"]
);

export default function (state = initialState, action) {
	const { endpoint, rateLimited } = action.payload || {};
	// some of these are also dispatched outside getTags, without an endpoint
	if (!tagListResultTypes.includes(action.type) || !endpoint) {
		return state;
	}
	return {
		...state,
		staleLists: { ...state.staleLists, [endpoint]: !!rateLimited },
	};
}
